import { Image } from '@react-pdf/renderer';
import React from 'react';
import { Flex } from '../../pdf-design-system';

export default function WinesFromSpainTableSignHeader({ style }) {
  return (
    <Flex style={[{ alignItems: 'center', justifyContent: 'center' }, style]}>
      <Image src="https://res.cloudinary.com/bottlebooks/image/upload/v1656665985/pdf-objects/WinesFromSpain/GermanyBanner2020.png" />
    </Flex>
  );
}
